/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const EditStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M17.614 9.67783L14.3222 6.38598M6.97362 20.3182L20.2131 7.07877C20.6476 6.64423 20.8649 6.42696 20.9463 6.17642C21.0179 5.95603 21.0179 5.71864 20.9463 5.49826C20.8649 5.24772 20.6476 5.03045 20.2131 4.5959L19.4041 3.78692C18.9696 3.35238 18.7523 3.13511 18.5017 3.0537C18.2814 2.9821 18.044 2.9821 17.8236 3.0537C17.573 3.13511 17.3558 3.35238 16.9212 3.78692L3.68177 17.0264L3 21L6.97362 20.3182Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { EditStrokeIcon };
